import axios from 'axios';

const getList = params => axios.get('/mensagens', {
  params,
});
const get = id => axios.get(`/mensagens/${id}`, {});

const save = (mensagem) => {
  if (mensagem.id) {
    return axios.put(`/mensagens/${mensagem.id}`, mensagem);
  }
  return axios.post('/mensagens', mensagem);
};

const updateMensagemPadrao = mensagem => axios.put(`/mensagens/${mensagem.id}/atualizar-padrao`, mensagem);

const remover = id => axios.delete(`/mensagens/${id}`);

export default {
  getList,
  get,
  save,
  remover,
  updateMensagemPadrao,
};
